import { Icon } from '@iconify/react';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { firestore } from '../../../../../contexts/FirebaseContext';
import useAuthUsers from '../../../../../hooks/useAuthUsers';
import useUserListRole from '../../../../../hooks/useUserListRole';
import UsersToSelect from './UsersToSelect';

const assignedRoles = ['cajero', 'cliente-corporativo'];

export default function UserRoles({ data, adminId }) {
  const [rol, setRol] = useState('');
  const [loading, setLoading] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [roles, setRoles] = useState([]);

  const role = useUserListRole(data.id);
  const { enqueueSnackbar } = useSnackbar();
  const { currentUser } = useAuthUsers();
  const roleName = currentUser?.role;

  console.log('mi rol actual', roleName);
  // console.log('roles local', ROLES);

  const handleRol = (e) => {
    setRol(e.target.value);
  };

  const submitRol = async (hostData) => {
    if (roleName === 'superusuario' || roleName === 'almighty') {
      setLoading(true);
      if (rol === 'almighty' && roleName === 'almighty') {
        try {
          await firestore
            .collection('users')
            .doc(data.id)
            .update({ ...hostData, role: rol });

          enqueueSnackbar('Rol actualizado', { variant: 'success' });
          setLoading(false);
          setOpenConfirm(false);
        } catch (error) {
          console.log(error.response);
          setLoading(false);
          enqueueSnackbar('Se produjo un error', { variant: 'error' });
          setOpenConfirm(false);
        }
      } else if (roleName !== 'almighty' && rol === 'almighty') {
        enqueueSnackbar('Solo un usuario con rol de Almighty puede dar credenciales de Almighty a otro', {
          variant: 'error'
        });
        setLoading(false);
      } else if (roleName !== 'almighty' && role === 'almighty') {
        enqueueSnackbar('Solo un usuario con rol de Almighty puede dar credenciales de Almighty a otro', {
          variant: 'error'
        });
        setLoading(false);
      } else {
        try {
          await firestore
            .collection('users')
            .doc(data.id)
            .update({ ...hostData, role: rol });

          enqueueSnackbar('Rol actualizado', { variant: 'success' });
          setLoading(false);
          setOpenConfirm(false);
        } catch (error) {
          console.log(error.response);
          setLoading(false);
          enqueueSnackbar('Se produjo un error', { variant: 'error' });
          setOpenConfirm(false);
        }
      }
    } else {
      enqueueSnackbar('Solo un super usuario puede hacer el cambio de roles', { variant: 'error' });
    }
  };

  useEffect(() => {
    setRol(role);
  }, [role]);

  useEffect(() => {
    firestore.collection('roles').onSnapshot((snapshot) => {
      const roles = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setRoles(roles);
    });
  }, []);
  return (
    <Card sx={{ padding: '15px' }}>
      <Box marginTop="15px" display="flex" flexDirection="column">
        <FormControl>
          <FormLabel id="demo-radio-buttons-group-label">Roles</FormLabel>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="female"
            name="radio-buttons-group"
            value={rol}
            onChange={handleRol}
          >
            {roles.map((rol) => (
              <FormControlLabel
                onClick={(e) => {
                  setOpenConfirm(true);
                  //   setSelectedRol(e.target.value);
                }}
                key={rol.id}
                value={rol.id}
                control={<Radio />}
                label={rol.displayName}
              />
            ))}
            {/* <FormControlLabel value="male" control={<Radio />} label="Cliente-licenciatario" />
              <FormControlLabel value="other" control={<Radio />} label="Usuario" /> */}
          </RadioGroup>
        </FormControl>
        <Box marginTop="15px" display="flex" gap="10px">
          {/* <Button variant="contained" color="error" onClick={() => setOpenConfirm(true)}>
              Guardar nuevo rol
            </Button> */}
          <ConfirmDialog
            open={openConfirm}
            onClose={setOpenConfirm}
            submitRol={submitRol}
            loading={loading}
            adminId={adminId}
            setLoading={setLoading}
            selectedRol={rol}
          />
          {/* <Button onClick={() => setUpdateRol(false)} variant="contained" color="info">
              Cerrar
            </Button> */}
        </Box>
      </Box>
    </Card>
  );
}

function ConfirmDialog({ open, onClose, submitRol, loading, setLoading, adminId, selectedRol }) {
  // de esta cinstante depende si lo primero que se vea sea
  const [viewSection, setViewSection] = useState(1);
  const [hostUserSelected, setHostUserSelected] = useState('');

  const hadnleHostUserSelect = (hostUserId) => {
    setHostUserSelected(hostUserId);
  };

  console.log('lo que llega', selectedRol, viewSection);

  useEffect(() => {
    if (assignedRoles.includes(selectedRol)) {
      setViewSection(0);
      console.log('se hace la modif', selectedRol, assignedRoles.includes(selectedRol));
    } else {
      setViewSection(1);
    }
  }, [selectedRol]);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    onClose(false);
  };

  const acceptSubmit = async (data) => {
    console.log(data);
    setLoading(true);
    let userNip;
    await firestore
      .collection('users')
      .doc(adminId)
      .get()
      .then((doc) => {
        userNip = doc.data().nip;
      })
      .catch((error) => {
        console.log(error.response);
        // setLoading(true);
        enqueueSnackbar('Se ha producido un error', { variant: 'error' });
        setLoading(false);
      });

    if (data.nip === userNip) {
      console.log('los nip son correctos');
      if (hostUserSelected) {
        const obj = {
          hostUser: hostUserSelected
        };
        submitRol(obj);
      } else {
        const obj = {};
        submitRol(obj);
      }
    } else {
      setLoading(false);
      enqueueSnackbar('Ingrese un codigo NIP valido', { variant: 'error' });
    }
  };

  useEffect(() => {
    setHostUserSelected('');
  }, [open]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Esta seguro que desea cambiar el rol de este usuario</DialogTitle>
      <DialogContent>
        {viewSection === 0 && (
          <UsersToSelect hadnleHostUserSelect={hadnleHostUserSelect} hostUserSelected={hostUserSelected} />
        )}

        <Card sx={{ padding: '15px', marginTop: '15px' }} component="form" onSubmit={handleSubmit(acceptSubmit)}>
          <Box marginBottom="15px">
            <TextField
              type="password"
              fullWidth
              {...register('nip', { required: true })}
              variant="outlined"
              label="NIP"
            />
            {errors.nip && (
              <Typography color="error" fontSize="13px">
                Ingrese su NIP
              </Typography>
            )}
          </Box>
          {/* <Box marginBottom="15px">
              <TextField fullWidth {...register('message', { required: true })} variant="outlined" label="Mensaje" />
              {errors.message && (
                <Typography color="error" fontSize="13px">
                  Ingrese un mensaje
                </Typography>
              )}
            </Box> */}
          <LoadingButton loading={loading} fullWidth variant="contained" type="submit">
            Cambiar rol
          </LoadingButton>
        </Card>
      </DialogContent>
      <DialogActions>
        {/* <LoadingButton loading={loading} variant="contained" color="info" onClick={submitRol}>
            Aceptar
          </LoadingButton> */}

        <Button onClick={handleClose} startIcon={<Icon icon="eva:arrow-back-fill" />}>
          Volver
        </Button>
      </DialogActions>
    </Dialog>
  );
}
